export const containsHTML = (str: string): boolean =>
  /<[a-z][\s\S]*>/i.test(str);
